import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { registerLicense } from '@syncfusion/ej2-base';
import { createRoot } from 'react-dom/client';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import MemberConfirmation from 'components/MemberConfirmation';
import AuthProvider from 'contexts/AuthProvider';
import { ConfigProvider, useConfigContext } from 'contexts/ConfigProvider';
import App from './App';
import { initAppInsights } from './components/Logging/ApplicationInsights';
import { WithAppInsightContext } from './contexts/AppInsightsProvider';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement as HTMLElement);

const AppInsightsWrapper = ({ children }) => {
    const { configValues } = useConfigContext();
    const { syncfusionLicenseKey, instrumentationKey } = configValues;
    registerLicense(syncfusionLicenseKey!);
    const appInsights = initAppInsights(instrumentationKey);

    return (
        <WithAppInsightContext appInsights={appInsights}>
            {children}
        </WithAppInsightContext>
    );
};
const routes = (
    <Route errorElement={<ErrorBoundary />}>
        <Route
            path="/member-confirm/:clientId"
            element={<MemberConfirmation />}
        />
        <Route
            path="/*"
            element={
                <AuthProvider>
                    <App />
                </AuthProvider>
            }
        />
    </Route>
);
const router = createBrowserRouter(createRoutesFromElements(routes));
root.render(
    <ConfigProvider>
        <AppInsightsWrapper>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
                <RouterProvider router={router} />
            </LocalizationProvider>
        </AppInsightsWrapper>
    </ConfigProvider>
);

unregisterServiceWorker();
